// extracted by mini-css-extract-plugin
module.exports = {"CarrouselActus":"carrouselActus_CarrouselActus__2E0vN"};